import "@/styles/index.less"; // global css
import "swiper/dist/css/swiper.css";

import Vue from "vue";
import VueAwesomeSwiper from "vue-awesome-swiper";
import { toast } from "@luzhongk/vue-request";

import * as filters from "@/utils/filters";
import request from "@/utils/request";
import MyComponent from "@/common"; // 全局组件

import App from "./App";

import store from "./store";
import router from "./router";

Vue.prototype.$http = request;
Vue.prototype.$toast = toast;

Object.entries(filters).forEach(([key, value]) => {
  Vue.filter(key, value);
});

// 注册全局组件
Vue.use(MyComponent);
Vue.use(VueAwesomeSwiper /* { default global options } */);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
